<section class="container">
<h3>{{ "My Courses" | translate }}</h3>
</section>